var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.715,
    height: 10.286,
    viewBox: "0 0 13.715 10.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0e132b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.714 -0.143)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.425,981.331a1.223,1.223,0,0,0-.841.374c-2.369,2.374-4.531,4.708-6.82,7.038l-2.806-2.239a1.223,1.223,0,1,0-1.529,1.91l3.67,2.934a1.224,1.224,0,0,0,1.628-.091c2.635-2.639,5-5.236,7.584-7.825a1.223,1.223,0,0,0-.887-2.1Z",
    transform: "translate(-22.685 -981.188)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/Checklist.bd69026a.svg";
export { ForwardRef as ReactComponent };